import { render, staticRenderFns } from "./ChangeOrderStatus.vue?vue&type=template&id=0b052cb2&scoped=true&"
import script from "./ChangeOrderStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeOrderStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b052cb2",
  null
  
)

export default component.exports